function bookingsForStaff(staffMember, eventBookings) {
  return eventBookings.filter(booking => {
    const staffMemberId = parseInt(staffMember.id, 10)
    const assignedStaffIds = booking.attributes.staffMemberIds.map(id => parseInt(id, 10))
    return assignedStaffIds.includes(staffMemberId)
  })
}

export default bookingsForStaff
